import { useTranslation } from 'react-i18next';

export const useTranslateProduct = () => {
  const { t } = useTranslation();

  return (value) => {
    if (!value) return '';

    // Handle unmapped product case
    if (value.toUpperCase() === 'UNMAPPED PRODUCT') {
      return t('dealView.details.unmappedProduct');
    }

    // Parse the input string
    const parts = value.split(' ');
    const number = parts[0];
    const unit = parts[1].toLowerCase(); // 'year' or 'month'
    
    // Build the translation key based on the remaining words
    const remainingWords = parts.slice(2).join('');
    let translationKey = '';

    switch (remainingWords.toLowerCase()) {
      case 'fixed':
        translationKey = 'yearFixed';
        break;
      case 'insured':
        translationKey = 'yearInsured';
        break;
      case 'insurable':
        translationKey = 'yearInsurable';
        break;
      case 'armclosedinsurable':
        translationKey = 'yearARMClosedInsurable';
        break;
      case 'armclosedinsured':
        translationKey = 'yearARMClosedInsured';
        break;
      case 'armclosed':
        translationKey = 'yearARMClosed';
        break;
      case 'fixedftp':
        translationKey = 'yearFixedFTP';
        break;
      case 'open':
        translationKey = 'monthOpen';
        break;
      default:
        return value; // Return original value if no match
    }

    return `${number} ${t(`dealView.details.${translationKey}`)}`;
  };
};